import Layout from '@/layout/index.vue'

const adminRoutes = [
    {
        path: '/',
        name: 'Dashboard',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '全局监控',
            icon: 'Monitor'
        },
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'Monitor',
                component: () => import('@/modules/dashboard/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '总览',
                    icon: 'Monitor'
                }
            },
            {
                path: 'dashboard/company/:cmpId',
                name: 'CompanyMonitor',
                component: () => import('@/modules/dashboard/company.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '企业监控总览',
                    icon: 'Monitor'
                }
            },
            {
                path: 'dashboard/project/:projId',
                name: 'ProjectMonitor',
                component: () => import('@/modules/dashboard/project.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '项目监控',
                    icon: 'Monitor'
                }
            }
        ]
    },
    {
        path: '/company',
        name: 'Company',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '企业组织',
            icon: 'OfficeBuilding'
        },
        children: [
            {
                path: '',
                name: 'CompanyList',
                component: () => import('@/modules/company/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '企业列表'
                },
            },
            {
                path: ':id/point',
                name: 'CompanyPointList',
                component: () => import('@/modules/point/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '监测列表',
                    hidden: true,
                    icon: 'FolderOpened'
                },
            },
            {
                path: ':id',
                name: 'ProejctList',
                component: () => import('@/modules/project/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '项目列表'
                },
            },
            {
                path: 'project/:projId',
                name: 'ProejctDetail',
                component: () => import('@/modules/project/detail.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '资源配置'
                },
            }
        ]
    },
    {
        path: '/data',
        name: 'Data',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '硬件数据',
            icon: 'DataAnalysis',
        },
        children: [
            {
                path: '',
                name: 'DataList',
                component: () => import('@/modules/data/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '列表'
                },
            }]
    },
    {
        path: '/device',
        name: 'Device',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '硬件设备',
            icon: 'Cpu'
        },
        children: [
            {
                path: 'terminal',
                name: 'TerminalList',
                component: () => import('@/modules/device/terminal.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '采集终端',
                    icon: 'Cellphone'
                },
            },
            {
                path: 'sensor',
                name: 'SensorList',
                component: () => import('@/modules/device/sensor.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '传感器',
                    icon: 'Odometer'
                },
            },
        ]
    },
    {
        path: '/proto',
        name: 'proto',
        component: Layout,
        redirect: 'receive',
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '协议管理',
            icon: 'Connection'
        },
        children: [
            {
                path: 'receive',
                name: 'Receivers',
                component: () => import('@/modules/proto/receive/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '接收协议',
                    icon: 'MessageBox'
                },
            },
            {
                path: 'send',
                name: 'Senders',
                component: () => import('@/modules/proto/send/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '转发协议',
                    icon: 'Promotion'
                },
            },
            {
                path: 'template',
                name: 'Template',
                component: () => import('@/modules/proto/template/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '协议模版',
                    icon: 'List'
                },
            },
        ]
    },
    {
        path: '/user',
        name: 'User',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '平台用户',
            icon: 'User'
        },
        children: [
            {
                path: '',
                name: 'UserList',
                component: () => import('@/modules/user/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '列表'
                },
            }]
    },
    {
        path: '/log',
        name: 'Log',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '请求日志',
            icon: 'Memo'
        },
        children: [
            {
                path: '',
                name: 'RequestLog',
                component: () => import('@/modules/log/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '列表'
                },
            }]
    },
    {
        path: '/exception',
        name: 'Exception',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '故障日志',
            icon: 'Warning'
        },
        children: [
            {
                path: '',
                name: 'ExceptionLog',
                component: () => import('@/modules/exception/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '列表'
                },
            }]
    },
    {
        path: '/tool',
        name: 'Tool',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '调试工具',
            icon: 'Tools',
        },
        children: [
            {
                path: '',
                name: 'Serialport',
                component: () => import('@/modules/serialport/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '校准工具',
                    icon: 'Aim',
                },
            },
            {
                path: 'statistic',
                name: 'Statistic',
                component: () => import('@/modules/statistic/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '数据分析',
                    icon: 'MagicStick'
                },
            }]
    },
    {
        path: '/resource',
        name: 'Resource',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '文件资源',
            icon: 'Files'
        },
        children: [
            {
                path: '',
                name: 'AssetsList',
                component: () => import('@/modules/asset/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源列表',
                    icon: 'Picture'
                },
            }
        ]
    },
]

export default adminRoutes;